import Reaccion from "./Reaccion";
export default Reaccion;